/**
 * @module wdh-hearing-test
 */

import WDHQuiz from './src/js/wdh-quiz';
export default WDHQuiz;